// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-icon {\n  margin-right: var(--icon-margin-right, 4px);\n  font-size: var(--icon-font-size, 44px);\n}\n\n.editable {\n  cursor: pointer;\n}\n\n.selected {\n  --icon-color: var(--icon-color-selected);\n}\n\n:not(.selected) {\n  --icon-color: var(--icon-color-not-selected);\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
